import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { INotification } from "~/routes/portal/type";

// import { VerifyOtpResponseDto } from "./endpoints";
import { ReduxState } from "../store";

export interface ModelState {
  modelId: string;
  notifications: INotification[];
}

const initialState: ModelState = {
  modelId: "",
  notifications: [],
};

export const modelSlice = createSlice({
  name: "models",
  initialState,
  reducers: {
    selectModelId: (state, action: PayloadAction<string, string>) => {
      state.modelId = action.payload;
    },

    resetModelId: (state) => {
      state.modelId = "";
    },

    addNotification: (state, action: PayloadAction<INotification>) => {
      // state.notifications = [...state.notifications, action.payload];
      if (!Array.isArray(state.notifications)) {
        console.error(
          "state.notifications is not an array",
          state.notifications,
        );
        state.notifications = []; // Reset to an empty array if corrupted
      }
      state.notifications = [...state.notifications, action.payload];
    },

    removeNotification: (state, action: PayloadAction<string>) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload,
      );
    },

    clearNotifications: (state) => {
      state.notifications = [];
    },
  },
});

function createSelector<T>(
  fn: (d: ReduxState["persistedReducer"]["models"]) => T,
) {
  return ({ persistedReducer: { models } }: ReduxState) => fn(models);
}

export const models = createSelector((models: ModelState) => models);

export const modelActions = modelSlice.actions;

const modelReducer = modelSlice.reducer;

export default modelReducer;
